import React from 'react';
import cn from 'classnames';
import { ModuleHeader } from '../../../components';
import {
  SponsorsModuleTitleAlignmentTypes,
  SponsorsModuleType,
} from '../types';
import SponsorCard from '../../../../productFilter/cards/SponsorCard';
import { PropsWithTestId } from '../../../../../../../types';
import { CallToAction } from '../../../../CallToActionGroup';
import { generateDomainUrl } from '../../../../../../../helpers/generateDomainUrl';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import { useSponsorBlocks } from '../hooks';
import s from './LogosAndTextDisplayStyle.module.scss';

export interface LogosAndTextDisplayStyleProps extends SponsorsModuleType {}

export function LogosAndTextDisplayStyle(
  props: PropsWithTestId<LogosAndTextDisplayStyleProps>,
) {
  const {
    '@type': type,
    title,
    titleSize,
    link,
    titleAlignment,
    sponsorsOrder,
    sponsorsFromDiscovery = [],
    testId,
  } = props;
  const { tenantsConfig: domains } = useRootSelector(selectPageConfig);
  const sponsorBlocks = useSponsorBlocks(sponsorsFromDiscovery, sponsorsOrder);

  const titleRowClassName = cn('row', {
    'end-xs': titleAlignment === SponsorsModuleTitleAlignmentTypes.RIGHT,
    'center-xs': titleAlignment === SponsorsModuleTitleAlignmentTypes.CENTRE,
  });

  return (
    <div className="container" data-testid={testId}>
      {title && (
        <div className={titleRowClassName}>
          <div className="col-xs-12">
            <ModuleHeader
              title={title}
              titleSize={titleSize}
              lineAfterHeading
            />
          </div>
        </div>
      )}
      {sponsorBlocks.map((sponsorBlock, index) => (
        <div className={s.siteOffset} key={index}>
          <div className={titleRowClassName}>
            <div className="col-xs-12">
              <ModuleHeader title={sponsorBlock.siteName} lineAfterHeading />
            </div>
          </div>
          <div className="row">
            {sponsorBlock.spexs.map((sponsor, sponsorIndex) => {
              const path = `${sponsorBlock.sitePath}/sponsors/${sponsor.path}`;
              const url = generateDomainUrl({
                domains,
                tenant: sponsorBlock.tenant,
                path,
              });

              return (
                <div
                  className={`col-xs-6 col-sm-4 col-md-3 ${s.sponsorOffset}`}
                  key={sponsorIndex}
                >
                  <SponsorCard data={sponsor} url={url} />
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <div className="row">
        <div className="col-xs-12">
          {link?.type && (
            <CallToAction
              link={link}
              variant="contained"
              align="center"
              data-testid="hub-module-link"
              ga4={{
                module_type: type,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

LogosAndTextDisplayStyle.defaultProps = {
  testId: 'hub-sponsors-module-logos-and-text',
};
